import { VIDEO_TYPE_TUTORIAL, VideoType } from 'phoenix2/state/video/video';
import { useSelector } from 'react-redux';
import { getContentAssetsURL, getStaticAssetsURL } from 'phoenix2/state/assets/selectors';

/**
 * Custom hook to get the URLs for the video, poster and subtitles
 * @param videoId the assetId for the video
 * @param videoType the type of the video provided
 * @returns an object containing the URL for the poster, subtitles, and video
 */
export const useVideoUrls = (videoId: string, videoType: VideoType) => {
    const staticAssetsURL = useSelector(getStaticAssetsURL);
    const contentAssetsURL = useSelector(getContentAssetsURL);
    return {
        posterUrl:
            videoType === VIDEO_TYPE_TUTORIAL
                ? `${staticAssetsURL}/${videoId}.png`
                : `${contentAssetsURL}/${videoId}/poster`,
        subtitleUrl:
            videoType === VIDEO_TYPE_TUTORIAL
                ? `${staticAssetsURL}/${videoId}.vtt`
                : `${contentAssetsURL}/${videoId}/subtitles`,
        videoUrl:
            videoType === VIDEO_TYPE_TUTORIAL
                ? `${staticAssetsURL}/${videoId}.mp4`
                : `${contentAssetsURL}/${videoId}`,
    };
};
